
import { getPriceByLocale } from "~/utils/locale";

export default {
  name: "cal-product-tile-list",
  props: {
    para: Object,
    listType: String,
    listDetails: Object,
    productList: {
      type: Array,
      required: true,
    },
    cols: String,
    basis: String,
    headerTexts: String,
    hideQuickView: {
      type: Boolean,
      required: false,
      default: true,
    },
    startingPrice: String,
    nextAvbledate: String,
    showHeader: {
      default: true,
    },
    categorizedList: {
      default: false,
    },
    useProdTileV2: {
      type: Boolean,
      default: false,
    },
    skipVariantSelection:{
      type: Boolean,
      default: false,
    },
    hideRating: {
      type: Boolean,
      default: false,
    },
    tileContentHeight: {
      type: String,
      default: "!h-auto",
    },
    tileContentHeightMobile: {
      type: String,
      default: "!h-auto",
    },
    tileContentOpenedHeight: {
      type: String,
      default: "!h-auto",
    },
    tileContentOpenedHeightMobile: {
      type: String,
      default: "!h-auto",
    },
  },
  data(){
    return {
      openedTiles: [],
    };
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  created() {
    for (const product of this.productList) {
      for (const variant of product.variants) {
        variant.itemPrice = getPriceByLocale(
          this.$i18n.locale,
          variant.itemPrice
        );
        if (variant.itemSalesPrice) {
          variant.itemSalesPrice = getPriceByLocale(
            this.$i18n.locale,
            variant.itemSalesPrice
          );
        }
      }
    }
  },
  methods: {
    handleToggledTile(index){
      if(this.openedTiles.includes(index)){
        this.openedTiles.splice(this.openedTiles.indexOf(index), 1);
      } else {
        this.openedTiles.push(index);
      }
    },
    goToProductPage(product) {
      let deliveryDate = this.$dayjs(sessionStorage.deliveryDate);
      if (
        this.listType === "next_available_products" &&
        (deliveryDate < this.$dayjs(product.startDate) ||
          deliveryDate > this.$dayjs(product.endDate))
      ) {
        sessionStorage.deliveryDate = "";
      }

      this.$emit("productTileClick");
      this.$router.push(
        this.localePath(`/product/${encodeURIComponent(product?.handle)}`)
      );
    },
    goToProductPage(product) {
      let deliveryDate = this.$dayjs(sessionStorage.deliveryDate);
      if (
        this.listType === "next_available_products" &&
        (deliveryDate < this.$dayjs(product.startDate) ||
          deliveryDate > this.$dayjs(product.endDate))
      ) {
        sessionStorage.deliveryDate = "";
      }

      this.$emit("productTileClick");
      this.$router.push(
        this.localePath(`/product/${encodeURIComponent(product?.handle)}`)
      );
    },
    addProdToBasket(product, variant) {
      let deliveryDate = this.$dayjs(sessionStorage.deliveryDate);
      if (
        this.listType === "next_available_products" &&
        (deliveryDate < this.$dayjs(product.startDate) ||
          deliveryDate > this.$dayjs(product.endDate))
      ) {
        sessionStorage.deliveryDate = "";
      }

      this.$emit("productTileClick");
      let variantTitle = variant.displayTitle.trim().length > 0 ? variant.displayTitle.trim() : variant.parentProductTitle.trim();
      this.$store.dispatch("cartItem/SET_VARIANT_AUTO_SELECT", variantTitle);
      this.$router.push(
        this.localePath(`/product/${encodeURIComponent(product?.handle)}`)
      );
    },
    getCustomPara(product, para) {
      if (product?.productType?.key && para) {
        const { key } = product.productType;
        switch (key) {
          case "Subscription-Ongoing":
            return para.onGoingSubPara;
          case "Subscription-6":
            return para.customSub6Para;
          case "Subscription-3":
            if (product.displayTitle.includes("Winter Subscription")) {
              return para.customSubWinterPara;
            } else if (product.displayTitle.includes("Birthday Subscription")) {
              return para.customSubBDayPara;
            } else if (
              product.displayTitle.includes("Valentines Day Subscription")
            ) {
              return para.customSubVDayPara;
            } else {
              return para.customSub3Para;
            }
          case "mothers-day-subscription":
            return para.customSubMdayPara;
          default:
            return para.customSubPara;
        }
      } else {
        return "";
      }
    },
  },
};
